/**
 * Created by anthony on 4/16/14.
 */
var account = angular.module('account', ['classy', 'schoolInformation', 'contactInformation', 'anonymousMode', 'eula',
    'accountsAndBudgets', 'appSubcategories', 'financialAidYear']);
account.classy.controller({
    name: 'AccountSettingsController',
    inject: ['$scope', 'authServiceFactory'],
    init: function()
    {
        //this.$.activeSection = 'account';
        //this.$.versionNo = versionNo;
    }
});

stateProviders.push({
    name: 'schoolside.settings.account',
    abstract: true,
    url: '/account',
    templateUrl: 'fast/submodules/schoolside/settings/accountSettings/accountSettings.html?v=' + versionNo,
    controller: 'AccountSettingsController'
});

